import ViewConstructor from './../components/ViewConstructor';

class GalleryForgotPassword extends ViewConstructor {
  /**
    Function fired on mount.

    This adds event listeners for form submission and form mode change (create account or login)
  */
  componentDidEnter() {
    let that = this;
    let $ref = $(`#${ this.state.generatedId }`);
    let errRef = $ref.find('.errors');
    let successRef = $ref.find('.success');

    $ref.find('.gallery-form-forgot-password').off().on('submit', function(e) {
      if (e) { e.preventDefault(); }
        var email = $ref.find('input[name="email"]').val();
        
        that.state.api.forgotPassword(email, (res) => {
            if (res.status === 'success') {
                successRef.find('p').text('Please check your email for a link to reset your password.');
                successRef.slideDown();
                $(this).slideUp();
            } else {
                //console.log('fail', res);
                errRef.find('p').text('Something');
                $ref.find('.errors').slideDown();
            }
        });
    }); 
  }

  render() {
    return `
      <div class="login-container">
        <h2>Reset Your Password</h2>
        <div class="errors">
          <p></p>
        </div>
        <div class="success">
          <p></p>
        </div>
        <form class="gallery-form-forgot-password gallery-form">
            <label for="gallery_email">
                <span>Email:</span>
                <input type="email" name="email" required />
            </label>
            <div class="login-container__button-container">
                <button type="submit" class="gallery-btn-login">Send Reset Password Link</button>
            </div>
        </form>
      <div>
    `;
  }
}

export default GalleryForgotPassword;


// WEBPACK FOOTER //
// ./src/scripts/site/account-views/forgot-password.js